export function getKeyFromTab(tab) {
	if (!tab) {
		return null;
	}

	const binderId = tab.binderId !== null && tab.binderId !== undefined ? tab.binderId : null;
	return binderId !== null && binderId !== undefined ? `${binderId}-${tab.id}` : null;
}

export function getKeyFromBinderId(binderId, tabId) {
	if (binderId === null || binderId === undefined || tabId === null || tabId === undefined) {
		return null;
	}
	return `${binderId}-${tabId}`;
}
